import { render, staticRenderFns } from "./BaseCertificate.vue?vue&type=template&id=54163b6f&scoped=true"
import script from "./BaseCertificate.vue?vue&type=script&lang=js"
export * from "./BaseCertificate.vue?vue&type=script&lang=js"
import style0 from "./BaseCertificate.vue?vue&type=style&index=0&id=54163b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54163b6f",
  null
  
)

export default component.exports